import styles from "./styles.module.scss";
import WhitePlus from "@/assets/WhitePlus.svg";
import { useState } from "react";
import Title from "@/ui/Title";

export const Services = ({ title, banners = [], services = [], className = "" }) => {
  const [expandedBanner, setExpandedBanner] = useState(null);

  const [expandedCard, setExpandedCard] = useState(null);

  return (
    <section className={`${styles.wrapper} ${className}`}>
      <div className={styles.inner}>
        {title && <Title title={title} tag="h2" className={styles.centralTitle} data-sourceflow-prop="title" />}

        {/* Top: two wide banners stacked */}
        <div className={styles.banners}>
          {banners.slice(0, 2).map((b, i) => (
            <article
              key={i}
              className={`${styles.banner} ${expandedBanner === i ? styles.expanded : ""}`}
              style={{
                backgroundImage: `linear-gradient(180deg, rgba(0,34,42,0.25) 0%, rgba(0,34,42,0.50) 100%), url(${
                  b?.image?.url || ""
                })`,
              }}
              data-sourceflow-prop="banners"
            >
              <div className={styles.bannerRow}>
                <h3 className={styles.bannerTitle} data-sourceflow-prop="banners.title">
                  {b?.title || ""}
                </h3>
                <button
                  className={styles.readMoreButton}
                  onClick={() => setExpandedBanner(expandedBanner === i ? null : i)}
                >
                  <span className={styles.bannerCtaText}>
                    {expandedBanner === i ? "CLOSE" : b?.ctaText || "READ MORE"}
                  </span>
                  <WhitePlus aria-hidden="true" className={styles.squareIcon} />
                </button>
              </div>

              {expandedBanner === i && b?.description && <p className={styles.bannerDescription}>{b.description}</p>}
            </article>
          ))}
        </div>

        {/* Bottom: services row (5 tiles) */}
        <div className={styles.servicesRow}>
          {services.slice(0, 5).map((s, i) => {
            const toneClass =
              s?.tone === "tone2"
                ? styles.tone2
                : s?.tone === "tone3"
                ? styles.tone3
                : s?.tone === "tone4"
                ? styles.tone4
                : s?.tone === "tone5"
                ? styles.tone5
                : styles.tone1;

            return (
              <article
                key={i}
                className={`${styles.serviceCard} ${toneClass} ${expandedCard === i ? styles.expanded : ""}`}
                style={{
                  backgroundImage: `url(${s?.image?.url || ""})`,
                }}
                data-sourceflow-prop="services"
              >
                <div className={styles.spacer} />
                <h4 className={styles.serviceTitle} data-sourceflow-prop="services.title">
                  {s?.title || ""}
                </h4>

                {expandedCard === i && s?.description && (
                  <p className={styles.serviceDescription} data-sourceflow-prop="services.description">
                    {s.description}
                  </p>
                )}

                <div className={styles.spacer} />
                <div className={styles.cardFooter}>
                  <button
                    className={styles.readMoreButton}
                    onClick={() => setExpandedCard(expandedCard === i ? null : i)}
                    data-sourceflow-prop="services.ctaText"
                  >
                    <span className={styles.readMoreText}>
                      {expandedCard === i ? "CLOSE" : s?.ctaText || "READ MORE"}
                    </span>
                    <WhitePlus aria-hidden="true" className={styles.squareIcon} />
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
